/**
 * Client display name with a fallback for blank imported names (Lloyd, Jul 8).
 *
 * Some Clio-imported clients have empty First/Last name fields, which rendered as a bare ", "
 * at the top of the Clients list (blank last names sort first). Fall back to email, then phone,
 * then an explicit placeholder so a row is never visually empty. Staff can fix the real name via
 * the client's Edit User screen.
 */
export function clientDisplayName(user: {
  User_FirstName?: string | null;
  User_LastName?: string | null;
  User_Email?: string | null;
  User_PhoneNumber?: string | null;
}): string {
  const first = (user.User_FirstName || '').trim();
  const last = (user.User_LastName || '').trim();
  if (first || last) {
    return last ? `${last}, ${first}`.replace(/, $/, '') : first;
  }
  const email = (user.User_Email || '').trim();
  const phone = (user.User_PhoneNumber || '').trim();
  return email || phone || '(no name on file)';
}
